export default __webpack_public_path__ + "dist/media/HandShake.5b05aaa4.png";